import { ThemeActionType } from '../action-types'

export const switchTheme = () => ({ type: ThemeActionType.SWITCH_THEME })